import React, { useContext, useMemo, useState } from 'react';
import { DialogBox } from '@mummssoftware/common-ui';
import VisitLog from '@mummssoftware/visit-log';
import { VisitsGlobalContext } from '@mummssoftware/global-context';
import { AppContext } from '../../../context';
import { visitsBy } from '../../../translations/en.json';

type ProviderVisitsModalProps = {
  onClose: any;
};

const MODAL_WIDTH = '95vw';
const MODAL_HEIGHT = '92vh';
const VISIT_LOG_HEADER_OFFSET = '40px';
const INVALID_EXPORT_NAME_CHARS = /[/\\:*?"<>|]/g;

export const ProviderVisitsModal = ({ onClose }: ProviderVisitsModalProps) => {
  const { patient, keycloak, agency, currentUser, pim, siteId } = useContext(
    AppContext,
  );
  const { providerInfo } = useContext(VisitsGlobalContext);

  const gridExportFileName = useMemo(() => {
    const first = providerInfo?.firstname?.trim();
    const last = providerInfo?.lastname?.trim();
    if (!first || !last) return undefined;
    const base = visitsBy
      .replace('{firstName}', first)
      .replace('{lastName}', last);
    return base.replace(INVALID_EXPORT_NAME_CHARS, '').trim();
  }, [providerInfo?.firstname, providerInfo?.lastname]);

  const [open, setOpen] = useState(true);

  const closeModal = () => {
    onClose();
    setOpen(false);
  };

  return (
    <DialogBox
      open={open}
      handleClick={onClose}
      disableBackdropClick
      maxWidth={false}
      hideBox
      style={{ overflow: 'hidden' }}
    >
      <div
        style={{
          width: MODAL_WIDTH,
          height: MODAL_HEIGHT,
          maxHeight: 'calc(100vh - 32px)',
        }}
      >
        <VisitLog
          embedded
          online
          smallWidget={false}
          agency={agency}
          currentUser={currentUser}
          patient={patient}
          patientNumber={patient?.patientNumber}
          visitAttributes={null}
          keycloak={keycloak}
          pim={pim}
          onClick={closeModal}
          siteId={siteId}
          gridExportFileName={gridExportFileName}
          height={`calc(${MODAL_HEIGHT} - ${VISIT_LOG_HEADER_OFFSET})`}
        />
      </div>
    </DialogBox>
  );
};
